import { LayoutModule } from '@angular/cdk/layout';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { NgIdleModule } from '@ng-idle/core';
import { CookieModule } from 'ngx-cookie';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { HammerConfig } from './core/configs/hammer-config';
import { CoreModule } from './core/core.module';
import { DemoDialogComponent } from './demo/demo-dialog/demo-dialog.component';
import { LiabilitiesModule } from './liabilities/liabilities.module';
import { OffersModule } from './offers/offers.module';
import { OnboardingModule } from './onboarding/onboarding.module';
import { SharedDialogsModule } from './shared-dialogs/shared-dialogs.module';
import { SharedModule } from './shared/shared.module';
import { TagInputModule } from 'ngx-chips';
import { AccountConsentsModule } from './account-consents/account-consents.module';
import { BannersModule } from './banners/banners.module';
import { SentryErrorHandlerService } from './sentry-error-handler.service';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

export function tokenGetter(): string {
  return localStorage.getItem('access_token');
}

@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent, DemoDialogComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    JwtModule.forRoot({
      config: {
        tokenGetter,
      },
    }),
    AuthModule,
    BannersModule,
    CoreModule,
    HttpClientModule,
    LayoutModule,
    CookieModule.forRoot(),
    SharedModule,
    NgxMaskDirective, NgxMaskPipe,

    NgIdleModule.forRoot(),
    SharedDialogsModule,
    FormsModule,
    ReactiveFormsModule,
    OnboardingModule,
    LiabilitiesModule,
    AppRoutingModule,
    OffersModule,
    HammerModule,
    TagInputModule,
    AccountConsentsModule,
  ],
  providers: [
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerConfig,
    },
    {
      provide: ErrorHandler,
      useClass: SentryErrorHandlerService,
    },
    provideNgxMask(),
  ],
})
export class AppModule {
}
